import NotImplementedError from '@/helpers/errors/NotImplementedError';
import { SxsDisplayTypes } from '../constants';
import stacked from './stacked';

const formatter = 'groupedSxs';

function getOverrides(kpi) {
  const overrides = {
    yaxis: { start: 'auto', end: 'auto' },
  };
  const isPercent = kpi.isPercentOperation();
  const metric = isPercent
    ? 'percent of time matching'
    : kpi.getMetricPropertyName(kpi.measurements[0]);
  const asPercent = kpi.getSxsDisplayType() === SxsDisplayTypes.DELTA_PERCENT;
  if (asPercent) {
    overrides.yaxis.title = `Percent difference between ${metric}`;
  } else {
    overrides.yaxis.title = `Difference between ${metric}`;
  }
  return overrides;
}

function formatGroupedSxsAsDelta(kpi, resultData) {
  const stack = stacked(kpi, resultData);
  stack.formatter = formatter;
  stack.overrides = getOverrides(kpi);
  return stack;
}

function formatGroupedSxsAsGroup(kpi, resultData) {
  const stack = stacked(kpi, resultData);
  stack.formatter = formatter;
  return stack;
}

export default function formatGroupedSxs(kpi, resultData) {
  const isDelta = kpi.getSxsDisplayType().startsWith('delta');
  const isGroup = !isDelta;

  if (isDelta) {
    return formatGroupedSxsAsDelta(kpi, resultData);
  }
  if (isGroup) {
    return formatGroupedSxsAsGroup(kpi, resultData);
  }

  throw new NotImplementedError('SxS when not group or delta');
}
